module.exports = __webpack_public_path__ + "img/changjian.26775a04.png";